import { bootstrapApplication } from '@angular/platform-browser';
import {
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
  PreloadAllModules,
  withComponentInputBinding,
} from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import { inject } from '@angular/core';
import localeDe from '@angular/common/locales/de';
import localeEnGb from '@angular/common/locales/en-GB';
import { OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { authInterceptor, DokaIdentityLoginService, provideDokaLogin } from '@doka/identity-login';
import { authCodeFlowConfig, environment } from './environments/environment';
import { provideAnimations } from '@angular/platform-browser/animations';
import { API_BASE_URL } from './api/services/generated/api-clients';
import { provideStartup } from './app/provider-funcs/provide-startup';
import { provideTokenRefresh } from './app/provider-funcs/provide-token-refresh';
import { provideDokaI18Next } from '@doka/i18next';
import {
  availableTranslations,
  defaultLocale,
  defaultTranslation,
  loadBundledLocale,
  loadBundledTranslation,
} from './app/locals/i18n-imports';
import { provideAngularCore } from '@doka/angular-core';
import { acceptLanguageInterceptor } from './app/interceptors/accept-language.interceptor';

registerLocaleData(localeDe);
registerLocaleData(localeEnGb);

bootstrapApplication(AppComponent, {
  providers: [
    /* importProvidersFrom(
      ApiModule.forRoot(
        () =>
          new Configuration({
            basePath: environment.yardApiUrl,
          }),
      ),
    ), */
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: OAuthStorage, useValue: localStorage },
    provideAngularCore({
      angularCoreConfig: {
        applyCustomStyles: false,
        awaitHandleTranslations: true,
      },
    }),
    provideIonicAngular(),
    provideAnimations(),
    provideOAuthClient(),
    provideDokaLogin({
      authCodeFlowConfig: {
        ...authCodeFlowConfig,
        // angular-oauth2-oidc accepts access tokens up to 10 min (default clock skew) past their expiry, the IDS and API only 5 min.
        // Shorten that so a stale token on page load leads to a new login instead of a failing userinfo call that blocks the app start.
        decreaseExpirationBySec: 6 * 60,
      },
      rootUrl: '/my-tasks',
      useServiceWorker: false,
    }),
    provideTokenRefresh(),
    provideStartup(),
    provideRouter(routes, withPreloading(PreloadAllModules), withComponentInputBinding()),
    //adds HTTP authorization header to non whitelisted requests using @doka/identity-login
    provideHttpClient(withInterceptors([acceptLanguageInterceptor, authInterceptor])),
    { provide: API_BASE_URL, useValue: environment.apiBaseUrl },
    provideDokaI18Next(() => {
      const loginService = inject(DokaIdentityLoginService);
      return {
        resources: defaultTranslation,
        locales: defaultLocale,
        useHttpBackend: false,
        idsUrl: authCodeFlowConfig.issuer,
        translationLoader: loadBundledTranslation,
        localeLoader: loadBundledLocale,
        isLoggedIn$: loginService.isLoggedIn$,
        supportedLanguages: availableTranslations
      };
    }),
  ],
});
